<!-- Footer组件出口文件-->
<template>
	<DynamicHome class="HeaderIndex"/>
</template>
<script>
	// 媒体查询断点为 700px
	const isPc = document.body.clientWidth >= 700;
	const path = isPc ? 'Pc' : 'Mobile';
	export default {
		name: 'HeaderIndex',
		components: {
			// https://webpack.js.org/api/module-methods/#import
			// 动态import问题 import 不接收 变量或者三元表达式
			'DynamicHome': () => import(`@/components/common/Header/${path}`)
		},
	};
</script>
